<template>
    <tr :class="headerRowClass">
        <template v-if="!isLoading">
            <th
                v-if="hasVModel && allowMultiselect"
                class="HeaderRow__check-box"
            >
                <RPCheckbox
                    :value="isAllChecked"
                    :indeterminate="isSomeChecked"
                    @input="toggleAll"
                    @indeterminate="deselect"
                />
            </th>
            <template v-for="header in headers">
                <Header
                    :key="`${header.label}-${header.key}`"
                    :active-sort="sort"
                    :active-sort-direction="sortDirection"
                    :property="header.key"
                    :label="header.label"
                    :sort-property="sortProperty"
                    :sortable="!!header.sortable"
                    @set-sort="e => $emit('set-sort', e)"
                />
            </template>
            <th v-if="showActionCell"></th>
        </template>
        <template v-else>
            <th
                v-for="t in headerCount"
                :key="t"
            ></th>
        </template>
    </tr>
</template>
<script>
import RPCheckbox from 'components/Basic/FormElements/RPCheckbox.vue';
import Header from './TableHeader.vue';
import stat from 'status/index';
import statusBuilder from 'status/statusBuilder';


export default {
    name: 'HeaderRow',
    components: {
        RPCheckbox,
        Header,
    },
    props: {
        headers: {
            type: Array,
            required: true
        },
        sortProperty: {
            type: Object,
            default: () => ({key: 'sort_by', direction: 'sort_direction'})
        },
        sort: {
            type: String,
            default: '',
        },
        hasVModel: {
            type: Boolean,
            required: true,
        },
        sortDirection: {
            type: String,
            default: 'asc',
            validator: val => ['asc', 'desc'].indexOf(val) !== -1,
        },
        isSomeChecked: {
            type: Boolean,
            required: true,
        },
        isAllChecked: {
            type: Boolean,
            required: true,
        },
        allowMultiselect: {
            type: Boolean,
            default: false,
        },
        showActionCell: {
            type: Boolean,
            default: false,
        },
        status: {
            type: String,
            default: stat.STANDBY,
        }
    },
    computed: {
        headerCount(){
            let c = this.headers.length;
            if(this.showActionCell) {
                c += 1;
            }
            if(this.hasVModel && this.allowMultiselect) {
                c += 1;
            }
            return c;
        },
        isLoading() {
            return this.status === stat.LOADING;
        },
        headerRowClass() {
            return statusBuilder('HeaderRow', this.status);
        }
    },
    methods: {
        toggleAll(){
            this.$emit('toggle-all', !this.isAllChecked);
        },
        deselect() {
            this.$emit('deselect');
        }
    },
};
</script>
<style lang="scss">
    .HeaderRow {
        height: 2rem;
        background: $grey-75;
        th:first-child{
            border-left: .25rem solid transparent;
            padding-left: 0.5rem;
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
        }
        th:last-child{
            padding-right: 0.5rem;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
        }
        th:nth-child(n+3):nth-last-child(n+2){
            overflow: hidden;
            text-overflow: ellipsis;
            padding: 0 0.5rem;
        }

        @include loading(2rem, 100%);
        &__check-box {
            padding-right: 0.5rem;
            width: 0.1%;
            white-space: nowrap;
        }
    }
</style>
